<header class="header">
  <div class="header-item item-center">
      <div class="menu-overlay"></div>
      <nav class="menu">
         
        <button class="scroll-btn left-btn" (click)="scrollLeft()" *ngIf="showLeftButton">
          <i class="pi pi-angle-left"></i>
        </button>

        <ul class="menu-main" #scrollableDiv>
            <li class="menu-item-has-children" 
                *ngFor="let mc of _ds?.departments_list;" 
                (mouseenter)="showSubMenu(mc.id)" 
                (mouseleave)="hideSubMenu()">

                <a class="menu-dep-a" [ngClass]="{ 'menu-dep-a-active': activeDepartment === mc.id }"
                   routerLink="/department/{{mc.slug_name}}" 
                  
                   (click)="onScrollEnlable(mc.slug_name);closeSubMenu()">
                    {{ mc.name }}
                    <span class="top-menu-li-span">{{ mc?.product_count }}</span>
                </a>
                <!-- [ngClass]="{ 'active-sub-menu': activeDepartment === mc.id }" -->
                <div class="sub-menu mega-menu active-sub-menu"  [ngClass]="{ 'active-sub-menu': activeDepartment === mc.id }">
                    <div class="sub-menu-overlay" (mouseenter)="hideSubMenu()"></div>
                    <div class="sub-menu-box">
                      <div class="sub-menu-in">
                        <div class="content-grid">
                            <!-- Category List Section -->
                            <div class="list-wrapper">
                                <div class="list-item" *ngFor="let subcat of mc?.sub_category_list">
                                    <h4 class="title" 
                                        routerLink="d/{{mc.slug_name}}/{{subcat.slug_name}}"
                                        [queryParams]="{ subCat: subcat.id }"
                                        (click)="closeSubMenu()">
                                        {{ subcat.name }}
                                    </h4>

                                    <ul class="line-limit">
                                        <li *ngFor="let typesubcat of subcat?.product_types">
                                            <a class="p-type-a" 
                                               (click)="onTypeLink(mc.slug_name, subcat.id, typesubcat.id); closeSubMenu()">
                                                {{ typesubcat.name }}
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>

                            <!-- Right Side Dedicated Image Column -->
                            <div class="image-column">
                                <img ngOptimizedImage 
                                     width="300" 
                                     height="450" 
                                     *ngIf="mc?.vertical_image" 
                                     src="{{mc?.vertical_image}}" 
                                     [alt]="mc?.name + ' - Image'" 
                                     loading="lazy">
                            </div>
                        </div>
                      </div>
                    </div>
                </div>
            </li>
        </ul>

        <button class="scroll-btn right-btn" (click)="scrollRight()" *ngIf="showRightButton">
          <i class="pi pi-angle-right"></i>
        </button>
       
      </nav>
  </div>
</header>
